<template>
  <div>
    <modal-new-order></modal-new-order>

    <div class="content-wrapper" v-if="!loadingComplete()">
      <section class="content">
        <div class="col-md-12">
          <div class="box box-primary">
            <div class="box-header">
              <h3 class="box-title">Chargement en cours</h3>
            </div>
            <div class="box-body">
              Chargement du bon de commande
            </div>
            <div class="overlay">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
          </div>
        </div>
      </section>
    </div>

    <div class="content-wrapper" v-if="loadingComplete()">
      <!-- Content Header (Page header) -->
      <section class="content-header" v-if="order_id!=0">
        <h1>
          Bon de commande <small> #{{getOrder.id}}</small> "{{getOrder.club.club}}"
        </h1>
        <ol class="breadcrumb">
          <li><a href="#"><i class="fa fa-dashboard"></i> Accueil</a></li>
          <li><a href="#">Bon de commande</a></li>
          <li class="active"><a href="#">#{{getOrder.id}}</a></li>
        </ol>
      </section>

      <section class="content-header" v-if="order_id==0">
        <h1>
          Bon de commande
          <small></small>
        </h1>
        <ol class="breadcrumb">
          <li><a href="#"><i class="fa fa-dashboard"></i> Accueil</a></li>
          <li class="active"><a href="#">Bons de commande</a></li>
        </ol>
      </section>

      <section class="content">
        <div class="row">
          <div class="col-md-12">
            <div class="nav-tabs-custom nav-tabs-custom-bottom">
              <ul class="nav nav-tabs" role="tablist">
                <li :class="{ 'active': order_id!=0 }" v-if="order_id!=0">
                  <a href="#member_tab_1"
                     aria-controls="#member_tab_1"
                     data-toggle="tab"
                     aria-expanded="false">Bon de commande</a>
                </li>
                <li :class="{ 'active': order_id==0 }">
                  <a href="#member_tab_2"
                     aria-controls="#member_tab_2"
                     data-toggle="tab"
                     aria-expanded="false">Listing des bons de commande</a>
                </li>

              </ul>
            </div>
          </div>
        </div>
        <div class="row tab-content">
          <div v-if="order_id!=0" role="tabpanel" class="col-md-12 tab-pane" :class="{ 'active': order_id!=0 }"
               id="member_tab_1">
            <MainFormOrder
              v-if="order_id!=0"
              :loadingTableProduits="loading"
              @onNeedRefreshOrder="refreshOrder()"
            ></MainFormOrder>
          </div>

          <div role="tabpanel" class="col-md-12 tab-pane" :class="{ 'active': order_id==0 }" id="member_tab_2">
            <ListingOrder
              :refreshListing="refreshListing"
              :clubPreSelected="clubSelectedForFilter">
            </ListingOrder>
          </div>

        </div>
      </section>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex'
  import MainFormOrder from './MainFormOrder.vue'
  // import ModalNewOrder from './ModalNewOrder'
  import ListingOrder from './ListingOrder'

  export default {
    data() {
      return {
        loading: false,
        order_id: null,
        refreshListing: false,
        clubSelectedForFilter: 0
      }
    },
    props: {},
    computed: {
      ...mapGetters({
        getOrder: 'getOrder',
        getStatusOrder: 'getStatusOrder',
        getModesPayement:'getModesPayement',
        getModesLivraison:'getModesLivraison',
        getTypeProducts:'getTypeProducts',
        getRoute: 'getRoute',
      })
    },
    methods: {
      ...mapActions({
        setOrder: 'setOrder',
        setOrderOriginal: 'setOrderOriginal',
        setStatusOrder: 'setStatusOrder',
        setTextesOrder: 'setTextesOrder',
        setModesPayement: 'setModesPayement',
        setModesLivraison: 'setModesLivraison',
        setTypeProducts: 'setTypeProducts',
      }),
      // showModalNewOrder: function () {
      //   $('#modalNewOrder').modal()
      // },
      refreshOrder: function () {
        return this.loadOrder();
      },
      loadingComplete: function () {
        return this.order_id == 0 ? true :
          (this.getOrder != null && this.getStatusOrder != null)
      },
      loadStatutsOrders: function () {
        this.$http.get(this.getRoute('Secretariat.ordermyabft.getAllStatutsOrders')).then((response) => {
          this.setStatusOrder(response.body)
        }, (response) => {
        });
      },
      loadModesPayement: function () {
        this.$http.get(this.getRoute('Secretariat.ordermyabft.getAllModePayement')).then((response) => {
          this.setModesPayement(response.body)
        }, (response) => {
        });
      },
      loadModesLivraison: function () {
        this.$http.get(this.getRoute('Secretariat.ordermyabft.getAllModeLivraison')).then((response) => {
          this.setModesLivraison(response.body)
        }, (response) => {
        });
      },
      loadTypesProduct: function () {
        this.$http.get(this.getRoute('Secretariat.ordermyabft.getAllTypeProduct')).then((response) => {
          this.setTypeProducts(response.body)
        }, (response) => {
        });
      },
      // loadTextesEnvoi: function () {
      //     this.$http.get(this.getRoute('Secretariat.getTextesEnvoisOrderitulatif') + this.order_id)
      //         .then((response) => {
      //             this.setTextesOrder(response.body)
      //         }, (response) => {
      //             this.setTextesOrder(null)
      //         });
      // },
      loadOrder: function () {
        this.loading = true
        if (this.order_id == 0)
          return;
        this.$http.get(this.getRoute('Secretariat.ordermyabft.getInfosOrder') + this.order_id)
          .then((response) => {
            this.setOrder(response.body)
            this.setOrderOriginal(response.body) //Pour le bandeau de convertion en récap
            this.loading = false
          }, (response) => {
            this.loading = false
            this.setOrder(null)
            this.setOrderOriginal(null)
          });
      },
    },
    beforeRouteUpdate(to, from, next) {
      this.order_id = to.params.order_id;
      // console.log("Update to " + this.order_id)
      this.setOrder(null)
      this.setOrderOriginal(null)
      this.loadStatutsOrders()
      this.loadModesPayement()
      this.loadTypesProduct()
      this.loadModesLivraison()
      this.loadOrder()
      this.refreshListing=!this.refreshListing;
      next()

    },

    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.order_id = vm.$route.params.order_id
        if (vm.$route.params.filterClub)
          vm.clubSelectedForFilter = vm.$route.params.filterClub
        vm.setOrder(null)
        vm.loadStatutsOrders()
        vm.loadModesPayement()
        vm.loadModesLivraison()
        vm.loadTypesProduct()
        vm.loadOrder()
      })
    },
    watch: {},
    components: {
      MainFormOrder,
      // ModalNewOrder,
      ListingOrder,
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Secretariat/MyABFT/AppOrderMyABFT.vue